import z from "zod";

// TODO: Add actual error types for Classify external service
const classifyErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const classifyErrorTypeSchema = z.enum(classifyErrorTypeValues);
const ClassifyErrorType = classifyErrorTypeSchema.enum;
type ClassifyErrorType = z.infer<typeof classifyErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type ClassifyErrors = {
  errorType: typeof ClassifyErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for Classify errors
  data: Record<string, never>;
};

export const classifyErrorDetails: Record<ClassifyErrorType, ErrorDetails> = {
  [ClassifyErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Classify external service error",
  },
};
